import type { SVGProps } from "react";
export default function SvgDueDiligenceAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 112 112"
			{...props}
		>
			<foreignObject width={119} height={118.268} x={-3.5} y={-2.83398}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1110_686_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_i_1110_686)">
				<path
					fill="url(#paint0_linear_1110_686)"
					fillOpacity={0.6}
					d="M54.657 16.148a2.11 2.11 0 0 1 2.686 0A54.8 54.8 0 0 0 93.21 28.716c.92-.016 1.754.571 1.989 1.462a54.6 54.6 0 0 1-5.315 40.858 54.7 54.7 0 0 1-14.302 16.418 54.8 54.8 0 0 1-19.081 9.414 1.9 1.9 0 0 1-1.002 0 54.8 54.8 0 0 1-19.082-9.414 54.7 54.7 0 0 1-14.301-16.418A54.6 54.6 0 0 1 16.8 30.178c.235-.891 1.069-1.478 1.99-1.462a54.8 54.8 0 0 0 35.866-12.568"
				/>
				<path
					stroke="url(#paint1_linear_1110_686)"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M54.657 16.148a2.11 2.11 0 0 1 2.686 0A54.8 54.8 0 0 0 93.21 28.716c.92-.016 1.754.571 1.989 1.462a54.6 54.6 0 0 1-5.315 40.858 54.7 54.7 0 0 1-14.302 16.418 54.8 54.8 0 0 1-19.081 9.414 1.9 1.9 0 0 1-1.002 0 54.8 54.8 0 0 1-19.082-9.414 54.7 54.7 0 0 1-14.301-16.418A54.6 54.6 0 0 1 16.8 30.178c.235-.891 1.069-1.478 1.99-1.462a54.8 54.8 0 0 0 35.866-12.568"
				/>
			</g>
			<foreignObject width={82.5557} height={67.3701} x={14.7227} y={23.0752}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1110_686_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_i_1110_686)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M78.778 56.76Q69.668 71.946 56 71.946q-13.666 0-22.777-15.186Q42.333 41.575 56 41.575T78.778 56.76"
				/>
				<path
					stroke="url(#paint2_linear_1110_686)"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeOpacity={0.5}
					d="M78.778 56.76Q69.668 71.946 56 71.946q-13.666 0-22.777-15.186Q42.333 41.575 56 41.575T78.778 56.76"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="M50.939 56.76a5.062 5.062 0 1 0 10.124 0 5.062 5.062 0 0 0-10.124 0"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1110_686"
					x1={56.2091}
					x2={56.2091}
					y1={15}
					y2={97}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_686"
					x1={56}
					x2={25.7232}
					y1={15.898}
					y2={83.1823}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_686"
					x1={56.0004}
					x2={56.0004}
					y1={41.5752}
					y2={71.9456}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1110_686_clip_path" transform="translate(3.5 2.834)">
					<path d="M54.657 16.148a2.11 2.11 0 0 1 2.686 0A54.8 54.8 0 0 0 93.21 28.716c.92-.016 1.754.571 1.989 1.462a54.6 54.6 0 0 1-5.315 40.858 54.7 54.7 0 0 1-14.302 16.418 54.8 54.8 0 0 1-19.081 9.414 1.9 1.9 0 0 1-1.002 0 54.8 54.8 0 0 1-19.082-9.414 54.7 54.7 0 0 1-14.301-16.418A54.6 54.6 0 0 1 16.8 30.178c.235-.891 1.069-1.478 1.99-1.462a54.8 54.8 0 0 0 35.866-12.568" />
				</clipPath>
				<clipPath id="bgblur_1_1110_686_clip_path" transform="translate(-14.723 -23.075)">
					<path d="M78.778 56.76Q69.668 71.946 56 71.946q-13.666 0-22.777-15.186Q42.333 41.575 56 41.575T78.778 56.76" />
				</clipPath>
				<filter
					id="filter0_i_1110_686"
					width={119}
					height={118.268}
					x={-3.5}
					y={-2.83398}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_686" />
				</filter>
				<filter
					id="filter1_i_1110_686"
					width={82.5557}
					height={67.3701}
					x={14.7227}
					y={23.0752}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_686" />
				</filter>
			</defs>
		</svg>
	);
}
